import { Component, Inject } from '@angular/core';
import { Transaction } from '../../../models/transaction.interface';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TransactionStatusColor } from '../../../enums/transaction-status.enum';
import { VoidModalComponent } from '../void-modal/void-modal.component';
import { PaypointService } from '../../../services/paypoint.service';

@Component({
  selector: 'kt-transaction-details-modal',
  templateUrl: './transaction-details-modal.component.html',
  styleUrls: ['./transaction-details-modal.component.scss'],
})
export class TransactionDetailsModalComponent {
  transactionMode = true;
  voided = true;

  constructor(
    public dialogRef: MatDialogRef<TransactionDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { transaction: Transaction; organization: string },
    private dialog: MatDialog,
    private payPointService: PaypointService,
  ) {
    this.voided = this.data.transaction.void_status === 'Voided';
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getTransactionStatusColor(status: any): 'tertiary' | 'danger' | 'success' {
    return TransactionStatusColor[status];
  }

  voidTransaction() {
    const voidConfirmingDialog = this.dialog.open(VoidModalComponent, {
      width: '500px',
      data: { transaction: this.data.transaction },
    });
    voidConfirmingDialog.afterClosed().subscribe((result) => {
      this.dialogRef.close({ voided: result.voided });
    });
  }

  getContactName(uuid: string) {
    return this.payPointService.mappedContactFromListGetName(uuid);
  }

  getPaymentMethod(transaction: Transaction) {
    if (
      transaction.method_last4 &&
      transaction.method_last4 !== '' &&
      transaction.method_brand &&
      transaction.method_brand !== ''
    )
      return transaction.method_brand + `****` + transaction.method_last4;
    return 'Payment method not saved.';
  }
}
